<template>
<div>
  <div class="previewer">

  </div>

  <div v-if="false" class="vform-label white mt-2">{{ $t('export.themeColor') }}</div>
  <color-picker-and-field
      v-if="false"
      class="mb-2 mt-2"
      :field-background-color="themeColor"
      @saveColor="(color) => {setColor(color)}"
      @unsetColor="setColor(null)"
  />

  <div class="vform-label white mt-2">{{ $t('export.Logo') }} (optional)</div>
  <div @click="selectLogo = !selectLogo" class="d-inline-block lighter clickable mt-1">{{ $t('export.addLogo')}} <icon class="ml-1" type="plus" /></div>
  <div v-if="!logo && selectLogo" class="p-1 bg-darker mt-2 border-radius">
    <content-list
        class="logo-list mt-2"
        :value="null"
        type="media"
        list-name="webappMedia"
        :organization-ids="[organizationId]"
        :show-preview="true"
        @save="addLogo"
    />
  </div>
  <div v-if="logo" class="web-dummy mt-2">
    <div class="fake-login">
      <div class="button-1"></div>
      <div class="button-2"></div>
    </div>
    <preview
        class="logo"
        preview-id="logo"
        :asset-id="logo"
        :keep-original-size="true"
        :removable="false"
        :downloadable="false"
        />
    <div class="fake-content-right"></div>
    <div class="fake-nav-left"></div>
  </div>
  <div
      v-if="logo"
      @click="logo = null"
      class="settings-button d-inline-block mt-2">
    {{ $t('removeLogo') }}
  </div>
    
</div>
</template>

<script>
import ColorPickerAndField from "@/components/widgets/editors/ColorPickerAndField.vue";
import ContentList from "@/components/widgets/editors/ContentList.vue";
import Preview from "@/components/preview/Preview.vue";
import Icon from "@/components/Icon";
export default {
  name: "WebappDesigner",
  components: {ColorPickerAndField, ContentList, Preview, Icon},
  props: {
    organizationId: {type: String, required: true},
  },
  data() {
    return {
      footerText: '',
      logo: null,
      organizationName: null,
      themeColor: null,
      selectLogo: false
    }
  },
  methods: {
    setColor(color) {
      this.themeColor = color;
      this.update();
    },
    addLogo(logo) {
      this.logo = logo;
      this.update();
    },
    update() {
      this.$emit('setDesign', {
        footerText: this.footerText,
        logo: this.logo,
        organizationName: this.organizationName,
        themeColor: this.themeColor,
      })
    }
  }
}
</script>

<style lang="scss">
.web-dummy {
  background-color: #fff;
  padding: 3px;
  height: 160px;
  .fake-login {
    float: right;
    display: flex;
    .button-1, .button-2 {
      background-color: #ddd;
      width: 15px;
      height: 8px;
      margin-left: 2px;
    }
  }
  .fake-nav-left {
    margin-top: 15px;
    width: 21%;
    height: 60px;
    background-color: #ddd;
  }
  .fake-content-right {
    margin-top: 15px;
    float: right;
    width: 77%;
    height: 80px;
    background-color: #ddd;
  }

  .logo {
    max-width: 48px;
    img {
      max-width: 100%;
    }
  }
}
</style>

<style scoped lang="scss">
.logo-list {
  max-width: 200px;
  img {
    max-width: 100%;
  }
}
.bg-darker {
  background-color: #000;
}
</style>

